import React from 'react';
import HeroSection from '../../components/HeroSection/HeroSection';
import About from '../../components/About/About';
import Missions from '../../components/Missions/Missions';
import Technology from '../../components/Technology/Technology';
import Rockets from '../../components/Rockets/Rockets';
import Timeline from '../../components/Timeline/Timeline';

import SEO from '../../components/SEO';
import { buildStructuredData, getAbsoluteUrl, getKeywords, getRouteSeo, siteSeo } from '../../seo/seoUtils';

const Home = () => {
  const seo = getRouteSeo('/');

  return (
    <div>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={getKeywords(seo)}
        url={getAbsoluteUrl('/')}
        image={siteSeo.image}
        imageAlt={siteSeo.imageAlt}
        structuredData={buildStructuredData('/')}
      />
      <HeroSection />
      <About enableSEO={false} />
      <Technology />
      <Missions enableSEO={false} />
      <Rockets enableSEO={false} />
      <Timeline />
    </div>
  );
};

export default Home;
